import { dateTimeToString } from "@/shared/utils/Dates";
import { Filing } from "../models/Filing";
import ScrollableTextWithHighlighting from "../../../shared/components/scrollable-text-highlighting/ScrollableTextWithHighlighting";

interface FilingContentProps {
  filing: Filing;
}

export default function FilingContent({ filing }: FilingContentProps) {
  if (filing.url) {
    window.location.href = filing.url;
    return <></>;
  }

  return (
    <>
      <h2>{filing.title}</h2>
      <p>{dateTimeToString(filing.filingDate)}</p>
      {filing.fullText ? (
        <ScrollableTextWithHighlighting fullText={filing.fullText} />
      ) : (
        <p className="text-muted-foreground">No text available</p>
      )}
    </>
  );
}
